/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CheckConnectionAccessRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v2/cred_service.pb'
import {CheckConnectionAccessResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v2/cred_service.pb'


export const checkConnectionAccess = (request: CheckConnectionAccessRequest, options?: CashRequestOptions) => post<CheckConnectionAccessRequest, CheckConnectionAccessResponse>("/2.0/cash/check-connection-access", request, {...options, rejectOnError: true })